import Script from 'next/script';
import { Component as ComponentContainer } from '@styles/layout';
import { TrustpilotWidget } from '@components/common/trustpilot-widget';

export const TrustPilotContainer = () => {
  return (
    <ComponentContainer>
      <Script
        type="text/javascript"
        src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        strategy="lazyOnload"
      />
      <TrustpilotWidget />
    </ComponentContainer>
  );
};
